module.exports = __webpack_public_path__ + "img/icon_efs.3914cb87.png";